module.exports = __webpack_public_path__ + "img/bx-x.905fdbd0.svg";